/* eslint-disable @typescript-eslint/no-explicit-any */
import { useIntl } from 'react-intl';
import { Col, Form, FormInstance, Row, Select } from 'antd';
import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
  RangePicker,
} from '@/components/_common';
import { WorkOrderComplementType } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { AverageTicketFormValues } from '@/core/domain/workorder/ManagementCharts/ManagementChart.types';
import moment from 'moment';
import { isAppPortocar } from '@/index';

interface Props {
  form: FormInstance<AverageTicketFormValues>;
}

function AverageTicketChartModal({ form }: Props) {
  const intl = useIntl();
  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  return (
    <Form layout="vertical" form={form}>
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item
            name="dates"
            label={intl.formatMessage({
              id: 'dashboard.averageTicket.modal.form.startDate.endDate',
            })}
            rules={[defaultEmptyFieldError]}
            initialValue={[moment().subtract(5, 'months'), moment()]}
          >
            <RangePicker style={{ width: '100%', height: 48 }} />
          </Form.Item>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'dashboard.averageTicket.modal.form.types',
            })}
            name="types"
            rules={[defaultEmptyFieldError]}
            initialValue={WorkOrderComplementType.WorkOrder}
          >
            <Select
              style={{ width: '100%' }}
              options={[
                {
                  value: WorkOrderComplementType.Courtesy,
                  label: intl.formatMessage({
                    id: `dashboard.averageTicket.modal.form.${
                      isAppPortocar ? 'insideCourtesy' : 'courtesy'
                    }`,
                  }),
                },
                {
                  value: WorkOrderComplementType.Warranty,
                  label: intl.formatMessage({
                    id: 'dashboard.averageTicket.modal.form.warranty',
                  }),
                },
                {
                  value: WorkOrderComplementType.WorkOrder,
                  label: intl.formatMessage({
                    id: 'dashboard.averageTicket.modal.form.work_order',
                  }),
                },
                {
                  value: WorkOrderComplementType.TotalLoss,
                  label: intl.formatMessage({
                    id: 'dashboard.averageTicket.modal.form.total_loss',
                  }),
                },
                {
                  value: WorkOrderComplementType.Return,
                  label: intl.formatMessage({
                    id: 'dashboard.averageTicket.modal.form.return',
                  }),
                },
                {
                  value: WorkOrderComplementType.Revision,
                  label: intl.formatMessage({
                    id: 'dashboard.averageTicket.modal.form.revision',
                  }),
                },
              ]}
            ></Select>
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name="companiesIds"
            label={intl.formatMessage({
              id: 'dashboard.averageTicket.modal.form.companies',
            })}
          >
            <CompaniesInfiniteSelectField mode="multiple" />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}

export default AverageTicketChartModal;
